import { useQuery } from "react-query";
import { getSecurityCount } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetSecurityCount = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetSecurityCount",
    getSecurityCount,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
